export enum AppAlertIcon {
  'info' = 'info',
  'success' = 'check_circle',
  'error' = 'cancel',
  'warning' = 'warning',
}

export enum AppAlertBackgroundColor {
  'info' = '#E2F1FD',
  'success' = '#E7F9E9',
  'error' = '#FEE6E7',
  'warning' = '#FCF4C4',
}

export enum AppAlertColor {
  'info' = '#178EE3',
  'success' = '#2AAD3D',
  'error' = '#EF0731',
  'warning' = '#F2B21D',
}
